import { Component, inject, input, model, output, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
    DocumentTemplateCategoryDto,
    DocumentTemplateCategoryService,
} from "@malirang/api-client";
import {
    AlertService,
    Badge,
    Button,
    Icon,
    Input,
    ToastService,
} from "@malirang/front-share";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";

@Component({
    selector: "app-document-category-item",
    templateUrl: "./document-category-item.component.html",
    styleUrls: ["./document-category-item.component.css"],
    imports: [CommonModule, Icon, Input, Button, CdkDrag, CdkDragHandle, Badge],
})
export class DocumentCategoryItemComponent {
    readonly documentCategoryService = inject(DocumentTemplateCategoryService);
    readonly alertService = inject(AlertService);
    readonly toastService = inject(ToastService);

    refresh = output<void>();
    category = input.required<DocumentTemplateCategoryDto>();
    isUpdate = signal(false);
    value = model<string>("");

    handleUpdate() {
        this.isUpdate.set(true);
        this.value.set(this.category().name);
    }

    handleCancel() {
        this.isUpdate.set(false);
        this.value.set("");
    }

    submit() {
        if (!this.value()) {
            this.toastService.error("카테고리 이름을 입력해주세요.");
            return;
        }

        this.documentCategoryService
            .documentTemplateCategoryControllerUpdateDocument({
                id: this.category().id,
                body: { name: this.value() },
            })
            .subscribe({
                next: () => {
                    this.isUpdate.set(false);
                    this.refresh.emit();
                    this.toastService.success("카테고리가 수정되었습니다.");
                },
                error: (err) => {
                    this.toastService.error(err.message);
                },
            });
    }

    handleDelete() {
        this.alertService
            .open({
                title: "카테고리 삭제",
                content: `카테고리 "${this.category().name}"을(를) 삭제하시겠습니까?
      카테고리 삭제 후에는 복구할 수 없습니다.`,
                type: "danger",
                buttons: {
                    confirm: {
                        color: "red",
                    },
                },
                checkbox: {
                    text: "데이터 삭제 후 복구할 수 없음을 확인하였습니다.",
                },
            })
            .closed.subscribe({
                next: (result) => {
                    if (result?.action === "confirm") {
                        this.documentCategoryService
                            .documentTemplateCategoryControllerDeleteDocument({
                                id: this.category().id,
                            })
                            .subscribe({
                                next: () => {
                                    this.refresh.emit();
                                    this.toastService.success(
                                        "카테고리가 삭제되었습니다.",
                                    );
                                },
                                error: (err) => {
                                    this.toastService.error(err.message);
                                },
                            });
                    }
                },
            });
    }
}
